import {LoanPurposeActivity} from '@/models/simulation/LoanPurposeActivity';
import {OfferDataTableElementKey} from '@/components/calculator/results/offers/OfferTableElement';
import {AppDomain} from '@/env/enums/Domains';
import { ProductType } from '@/commons/enums/ProductType';
import { SimulationProductType } from '@/components/calculator/services/SimulationStore';

export type ExcludedSimulationRows = {
  [K in SimulationProductType]: OfferDataTableElementKey[]
}
export interface CalculatorConfig {
  hasMergedLiabilities: boolean;
  hasMergedLimits: boolean;
  hasMarketTypes: boolean;
  hasVersionSwitcher: boolean;
  hasFirstOrSubsequentRealEstateInfo: boolean;
  availableLoanPurposes: LoanPurposeActivity[];
  excludedSimulationRows: ExcludedSimulationRows;
}

const CommonExcludedElements = [
  OfferDataTableElementKey.TRANSITIONAL_INSTALLMENT_WITH_BRIDGE_INSURANCE,
  OfferDataTableElementKey.TRANSITIONAL_INSTALLMENT_LOW_PERSONAL_SHARE_INSURANCE,
  OfferDataTableElementKey.COSTS_SUM_LOW_PERSONAL_SHARE_INSURANCE,
  OfferDataTableElementKey.TRANCHE_ACCOUNTING,
  OfferDataTableElementKey.PERCENTAGE_FOR_WHICHEVER_EXPENSE,
  OfferDataTableElementKey.CONVERSION,
  OfferDataTableElementKey.LOW_PERSONAL_SHARE_INSURANCE,
  OfferDataTableElementKey.TRANSITIONAL_INSTALLMENT_WITH_BRIDGE_INSURANCE_BRIDGING_INSURANCE,
  OfferDataTableElementKey.COSTS_SUM_BRIDGING_INSURANCE,
  OfferDataTableElementKey.SECOND_INSURANCE,]

export const calculatorConfig: Record<keyof typeof AppDomain, CalculatorConfig> = {
  LENDI_PL: {
    hasMergedLiabilities: false,
    hasMergedLimits: false,
    hasMarketTypes: true,
    hasVersionSwitcher: true,
    hasFirstOrSubsequentRealEstateInfo: false,
    availableLoanPurposes: [
      LoanPurposeActivity.BUYING,
      LoanPurposeActivity.BUILDING,
      LoanPurposeActivity.RENOVATING,
      LoanPurposeActivity.ADAPTATION,
      LoanPurposeActivity.LOAN,
      LoanPurposeActivity.BUYING_AND_RENOVATING,
      LoanPurposeActivity.BUYING_PLOT_AND_BUILDING,
      LoanPurposeActivity.REFINANCING_RESIDENTIAL_REAL_ESTATE,
      LoanPurposeActivity.REFINANCING_NONRESIDENTIAL_REAL_ESTATE,
      LoanPurposeActivity.REFINANCING_REAL_ESTATE_LOAN,
      LoanPurposeActivity.REFINANCING_NON_REAL_ESTATE_LOAN,
      LoanPurposeActivity.HOME_DEBT_CONSOLIDATION_LOAN,
      LoanPurposeActivity.CONSUMER_DEBT_CONSOLIDATION_LOAN,
    ],
    excludedSimulationRows: {
      [ProductType.MORTGAGE]: [OfferDataTableElementKey.CONVERSION,],
      [ProductType.CASH]: [
        OfferDataTableElementKey.TRANSITIONAL_INSTALLMENT,
        OfferDataTableElementKey.CREDIT_CARD,
        OfferDataTableElementKey.TARGET_INSTALLMENT,
      ],
    },
  },
  NESTO_RO: {
    hasMergedLiabilities: true,
    hasMergedLimits: true,
    hasMarketTypes: false,
    hasVersionSwitcher: false,
    hasFirstOrSubsequentRealEstateInfo: true,
    availableLoanPurposes: [
      LoanPurposeActivity.BUYING,
      LoanPurposeActivity.BUILDING,
      LoanPurposeActivity.RENOVATING,
      LoanPurposeActivity.LOAN,
      LoanPurposeActivity.BUYING_PLOT_AND_BUILDING,
      LoanPurposeActivity.REFINANCING_REAL_ESTATE_LOAN,
      LoanPurposeActivity.REFINANCING_NON_REAL_ESTATE_LOAN,
    ],
    excludedSimulationRows: {
      [ProductType.MORTGAGE]: [...CommonExcludedElements,],
      [ProductType.CASH]: [...CommonExcludedElements, OfferDataTableElementKey.FIRST_INSTALLMENT,],
    },
  },
};
